import React from 'react';
import Routes from './Routes/index';
import { GlobalStyles } from './Styles/globalStyles';

const App: React.FC = () => {
  return (
    <>
      <Routes />
      <GlobalStyles />
    </>
  );
}

export default App;
